import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { AgreementCheckboxDesktop as AgreementCheckbox } from '@alfa-bank/site-agreement-checkbox/desktop';
import { Text } from '@alfa-bank/site-text-v2';
import { getCaption } from '@alfa-bank/site-helpers-form/meta/get-caption';
import { isError } from '@alfa-bank/site-helpers-form/meta/is-error';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';

import { validateAgreement } from '../utils';
import { FormAgreement as Component } from '../form-agreement';
import type { TFormAgreement, IDeps } from '../models';
import styles from '../styles/styles.css';

export const FormAgreementDesktop = createWidget<IDeps, TFormAgreement>({
    AgreementCheckbox,
    Field,
    Text,
    getCaption,
    isError,
    styles,
    validateAgreement,
})(Component);
